/* ==========================================================================
   INDIGO OSLO — product.js
   Variant selection.

   Sold-out sizes stay visible and struck through rather than hidden: with a
   median of 4 sizes per product, removing them makes the range look thinner
   than it is and hides the fact that a size existed at all.
   ========================================================================== */

(function () {
  'use strict';

  var T = window.theme || {};

  var form = document.querySelector('[data-product-form]');
  var dataEl = document.querySelector('[data-variant-data]');
  if (!form || !dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return; // malformed payload — the form still posts option values natively
  }
  if (!Array.isArray(variants) || !variants.length) return;

  var input = form.querySelector('[data-variant-input]');
  var button = form.querySelector('[data-add-button]');
  var label = form.querySelector('[data-add-label]');
  var priceHost = document.querySelector('.pdp__price');
  var skuHost = document.querySelector('[data-variant-sku]');
  var groups = form.querySelectorAll('[role="radiogroup"]');

  function selection() {
    var out = [];
    groups.forEach(function (group, i) {
      var active = group.querySelector('.size-opt.is-selected');
      out[i] = active ? active.dataset.optionValue : null;
    });
    return out;
  }

  function match(options) {
    return variants.find(function (v) {
      return options.every(function (val, i) {
        return val === null || v.options[i] === val;
      });
    });
  }

  /* An option value is offered if SOME variant carrying it is available —
     with a second option present, a size can be in stock in one colour and
     gone in another. */
  function availableWith(index, value, current) {
    return variants.some(function (v) {
      if (v.options[index] !== value) return false;
      if (!v.available) return false;
      return current.every(function (val, i) {
        return i === index || val === null || v.options[i] === val;
      });
    });
  }

  function updateAvailability() {
    var current = selection();

    groups.forEach(function (group, gi) {
      group.querySelectorAll('.size-opt').forEach(function (opt) {
        var ok = availableWith(gi, opt.dataset.optionValue, current);
        opt.disabled = !ok;
        if (!ok) {
          opt.setAttribute(
            'aria-label',
            opt.textContent.trim() + ' — ' + (T.strings.soldOut || 'Utsolgt')
          );
        } else {
          opt.removeAttribute('aria-label');
        }
      });
    });
  }

  function money(cents) {
    return T.formatMoney ? T.formatMoney(cents) : cents / 100;
  }

  function apply(variant) {
    if (!variant) {
      if (input) input.value = '';
      if (button) button.disabled = true;
      if (label) label.textContent = T.strings.soldOut || 'Utsolgt';
      return;
    }

    if (input) input.value = variant.id;

    if (button) button.disabled = !variant.available;
    if (label) {
      label.textContent = variant.available
        ? T.strings.addToCart || 'Legg i handlekurv'
        : T.strings.soldOut || 'Utsolgt';
    }

    if (priceHost) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html =
        '<span class="price__now' + (onSale ? ' price__now--sale' : '') + '">' +
        money(variant.price) +
        '</span>';
      if (onSale) {
        html += '<s class="price__was">' + money(variant.compare_at_price) + '</s>';
        var pct = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );
        html += '<span class="meta brass">&minus;' + pct + '%</span>';
      }
      priceHost.innerHTML = html;
    }

    if (skuHost && variant.sku) skuHost.textContent = variant.sku;

    // Keep the URL shareable — deep-linking a specific size should work.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  form.addEventListener('click', function (e) {
    var opt = e.target.closest('.size-opt');
    if (!opt || opt.disabled) return;

    var group = opt.closest('[role="radiogroup"]');
    group.querySelectorAll('.size-opt').forEach(function (o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-checked', 'false');
    });
    opt.classList.add('is-selected');
    opt.setAttribute('aria-checked', 'true');

    var err = form.querySelector('[data-add-error]');
    if (err) err.hidden = true;

    updateAvailability();
    apply(match(selection()));
  });

  // Arrow-key navigation within each radiogroup
  groups.forEach(function (group) {
    group.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
      e.preventDefault();

      var opts = Array.prototype.slice.call(group.querySelectorAll('.size-opt:not(:disabled)'));
      if (!opts.length) return;

      var i = opts.indexOf(document.activeElement);
      var next =
        e.key === 'ArrowRight' || e.key === 'ArrowDown'
          ? (i + 1) % opts.length
          : (i - 1 + opts.length) % opts.length;

      opts[next].focus();
      opts[next].click();
    });
  });

  updateAvailability();

  // Preselect the only available size when there is exactly one
  groups.forEach(function (group) {
    if (group.querySelector('.size-opt.is-selected')) return;
    var free = group.querySelectorAll('.size-opt:not(:disabled)');
    if (free.length === 1) free[0].click();
  });
})();
